 <div class="layout d-flex">
    <div class="sidebar">
      <app-left-nav></app-left-nav>
    </div>
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </div>
